/**
 * Locale Selector Modal
 * Handles the combined country and language selector modal
 * Desktop Only (990px and above)
 */

class LocaleSelectorModal {
  constructor() {
    // Only initialize on desktop
    if (window.innerWidth < 990) {
      return;
    }

    this.modal = document.getElementById('locale-selector-modal');
    if (!this.modal) return;

    this.overlay = this.modal.querySelector('.locale-modal__overlay');
    this.closeButtons = this.modal.querySelectorAll('[data-modal-close]');
    this.searchInput = document.getElementById('locale-search-input');
    this.regionButtons = this.modal.querySelectorAll('.locale-modal__region');
    this.countryItems = this.modal.querySelectorAll('.locale-modal__country-item');
    this.form = document.getElementById('locale-modal-form');
    this.countryInput = document.getElementById('locale-modal-country');
    this.languageInput = document.getElementById('locale-modal-language');
    this.localeCountriesList = this.modal.querySelector('#locale-countries-list');

    this.currentRegion = 'common';

    this.init();
  }

  init() {
    // Build country-language mapping from data attributes
    this.buildCountryLanguageMap();

    // Bind events
    this.closeButtons.forEach(btn => {
      btn.addEventListener('click', () => this.close());
    });

    this.overlay.addEventListener('click', () => this.close());

    this.searchInput.addEventListener('input', (e) => this.handleSearch(e.target.value));

    this.regionButtons.forEach(btn => {
      btn.addEventListener('click', (e) => this.handleRegionChange(e.target.dataset.region));
    });

    this.countryItems.forEach(item => {
      // Handle language option clicks (individual language buttons)
      const languageOptions = item.querySelectorAll('.locale-modal__language-option');
      languageOptions.forEach(langOption => {
        langOption.addEventListener('click', (e) => {
          e.stopPropagation(); // Prevent country button click

          if (window.merakiUtils && window.merakiUtils.localStorageSet) {
            window.merakiUtils.localStorageSet()
          }

          const countryCode = langOption.dataset.country;
          const languageCode = langOption.dataset.language;

          const parentButDom = langOption.closest('.locale-modal__country-item')
          const redirectPath = parentButDom.dataset.redirectPath;
          const currencyCode = parentButDom.dataset.currencyCode;
          if (parentButDom.getAttribute('data-action') === 'default') {
            if (window.merakiUtils && window.merakiUtils.submitCountryForm && window.merakiUtils.filterRedirectPath) {
              const returnHref = window.merakiUtils.filterRedirectPath(redirectPath)
              window.merakiUtils.submitCountryForm(countryCode, returnHref, languageCode, currencyCode)
            }
            return
          }

          const form = this.form;
            
          // 这里是站内跳转的特殊处理，对 CA AUS EU 等站点做处理
          if (window.merakiUtils && window.merakiUtils.formatReturnHref) {
            const returnHrefDom = form.querySelector('input[name="return_to"]');
            let returnTo = returnHrefDom ? returnHrefDom.value : '';
            returnTo = window.merakiUtils.formatReturnHref(returnTo, countryCode)
            returnHrefDom.value = returnTo;
          }
          this.submitSelection(countryCode, languageCode);
        });
      });

      // Handle country button click (fallback - use default language)
      item.addEventListener('click', (e) => {
        // Only trigger if clicked outside language options
        if (!e.target.closest('.locale-modal__language-option')) {

          if (window.merakiUtils && window.merakiUtils.localStorageSet) {
            window.merakiUtils.localStorageSet()
          }

          const countryCode = item.dataset.country;
          // const defaultLang = item.querySelector('.locale-modal__language-option')?.dataset.language || 'en';
          const defaultLang = window.Shopify?.locale || 'en';
          const redirectPath = item.dataset.redirectPath;
          const currencyCode = item.dataset.currencyCode;

          if (e.currentTarget.getAttribute('data-action') === 'default') {
            if (window.merakiUtils && window.merakiUtils.submitCountryForm && window.merakiUtils.filterRedirectPath) {
              const returnHref = window.merakiUtils.filterRedirectPath(redirectPath)
              window.merakiUtils.submitCountryForm(countryCode, returnHref, defaultLang, currencyCode)
            }
            return
          }

          const form = this.form;
            
          // 这里是站内跳转的特殊处理，对 CA AUS EU 等站点做处理
          if (window.merakiUtils && window.merakiUtils.formatReturnHref) {
            const returnHrefDom = form.querySelector('input[name="return_to"]');
            let returnTo = returnHrefDom ? returnHrefDom.value : '';
            returnTo = window.merakiUtils.formatReturnHref(returnTo, countryCode)
            returnHrefDom.value = returnTo;
          }
          this.submitSelection(countryCode, defaultLang);
        }
      });
    });

    // ESC key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.modal.hasAttribute('hidden')) {
        this.close();
      }
    });

    // Expose open method globally
    window.openLocaleModal = () => this.open();
  }

  buildCountryLanguageMap() {
    // Build the mapping from data attributes on country items
    window.localeCountryLanguageMap = {};

    this.countryItems.forEach(item => {
      const countryCode = item.dataset.country;
      const defaultLanguage = item.dataset.defaultLanguage;
      const availableLanguages = item.dataset.availableLanguages ? item.dataset.availableLanguages.split(',') : [];

      if (countryCode && defaultLanguage) {
        window.localeCountryLanguageMap[countryCode] = {
          default: defaultLanguage,
          available: availableLanguages
        };
      }
    });
  }

  open() {
    // Only open on desktop
    if (window.innerWidth < 990) {
      return;
    }

    this.modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';

    // Focus search input
    setTimeout(() => {
      this.searchInput.focus();
    }, 100);
  }

  close() {
    if (window.merakiUtils && window.merakiUtils.localStorageSet) {
      window.merakiUtils.localStorageSet()
    }
    this.modal.setAttribute('hidden', '');
    document.body.style.overflow = '';

    // Clear search
    this.searchInput.value = '';
    this.handleSearch('');

    // Reset to common region
    this.handleRegionChange('common');
  }

  handleSearch(searchTerm) {
    const term = searchTerm.toLowerCase().trim();

    this.countryItems.forEach(item => {
      // const searchText = item.dataset.searchText || '';

      // if (term === '' || searchText.includes(term)) {
      //   item.removeAttribute('hidden');
      // } else {
      //   item.setAttribute('hidden', '');
      // }
      const counryName = item.querySelector('.locale-modal__country-name')
      if (counryName) {
        const text = counryName.textContent.toLowerCase()
        if (text.includes(term)) {
          item.removeAttribute('hidden')
        } else {
          item.setAttribute('hidden', true)
        }
      }
    });
  }

  handleRegionChange(region) {
    this.currentRegion = region;

    // Update active button
    this.regionButtons.forEach(btn => {
      if (btn.dataset.region === region) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    const _that = this
    
    // Filter countries by region
    this.countryItems.forEach(item => {
      const itemRegion = item.dataset.region;

      // Common shows all countries
      if (region === 'common') {
        item.removeAttribute('hidden');
      } else {
        // Other regions show only their specific countries
        if (itemRegion === region) {
          item.removeAttribute('hidden');
        } else {
          item.setAttribute('hidden', '');
        }
      }
      if (region === 'north-america') {
        _that.localeCountriesList.classList.add('sort')
      } else {
        _that.localeCountriesList.classList.remove('sort')
      }
    });

    // Reapply search filter if there's a search term
    if (this.searchInput.value.trim() !== '') {
      this.handleSearch(this.searchInput.value);
    }
  }

  handleCountrySelect(item) {
    const countryCode = item.dataset.country;

    // Get default language for this country
    const languageCode = this.getDefaultLanguage(countryCode);

    // Set form values
    this.countryInput.value = countryCode;
    this.languageInput.value = languageCode;

    // Submit form
    this.form.submit();
  }

  getDefaultLanguage(countryCode) {
    // Use the country-language mapping from the global object
    const mapping = window.localeCountryLanguageMap || {};
    const countryData = mapping[countryCode];

    // Return the default language for this country, or fallback to first available language
    if (countryData) {
      return countryData.default || countryData.available[0] || 'en';
    }

    // Fallback to first available language globally
    return window.localeAvailableLanguages?.[0] || 'en';
  }

  submitSelection(countryCode, languageCode) {
    if (!countryCode || !languageCode) {
      console.error('Missing country or language code');
      return;
    }

    // Set form values
    this.countryInput.value = countryCode;
    this.languageInput.value = languageCode;

    // Submit form
    this.form.submit();
  }
}

// Initialize when DOM is ready - Desktop Only
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    if (window.innerWidth >= 990) {
      new LocaleSelectorModal();
    }
  });
} else {
  if (window.innerWidth >= 990) {
    new LocaleSelectorModal();
  }
}

// Re-initialize on window resize if crossing the desktop threshold
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    if (window.innerWidth >= 990 && !window.localeModalInstance) {
      window.localeModalInstance = new LocaleSelectorModal();
    }
  }, 250);
});